export default "__VITE_ASSET__2a688850__"